import { dotnetApi } from '@gik/core/api/ky/dotnetApi';

interface IPageInformation {
  description: string;
  specialNotes: string;
  title: string;
}

export function updatePageInformation(routeId: string, data: IPageInformation) {
  return dotnetApi.put(`inkinds/${routeId}/page-information`, {
    json: data,
  });
}

export function updatePagePhoto(routeId: string, base64Photo: string) {
  return dotnetApi.post(`inkinds/${routeId}/photo`, {
    body: base64Photo,
  });
}
